import { Deserializable } from '../../../models/protocols/deserializable';
import { PaylineCurrencyType } from './payline-currency-type';

export class PaylineAccount implements Deserializable {
  public id!: number;
  public memberId?: number;
  public bankName!: string;
  public accountNumber!: string;
  public active!: boolean;
  public createdDate!: string;
  public inUse!: boolean;
  public currency!: PaylineCurrencyType;

  onDeserialize() {
    if (this.currency) {
      this.currency = window?.injector?.Deserialize?.instanceOf(PaylineCurrencyType, this.currency);
    }
  }
}
